import { render } from "./MessageDialog.vue?vue&type=template&id=7bbe796c&ts=true"
import script from "./MessageDialog.vue?vue&type=script&lang=ts"
export * from "./MessageDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__